// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background-color: #313844;
  padding: 10px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  color: #140f40;
  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 50; /* Ensure footer stays above other content */
}
footer span {
  color: #3bc3f8; /* New blue color (Tailwind's blue-600) */
  opacity: 1;
  text-align: center;
  font-weight: 500;
}
footer li {
  margin-left: 30px;
}

.light footer {  
  color: #ffffff;
  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06);
}

.headingContainer {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  text-align: center;
}

/* Add body padding to prevent content from being hidden behind fixed footer */
body {
  padding-bottom: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,mFAAmF;EACnF,WAAW,EAAE,4CAA4C;AAC3D;AACA;EACE,cAAc,EAAE,yCAAyC;EACzD,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mFAAmF;AACrF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;AACtB","sourcesContent":["footer {\n  background-color: #313844;\n  padding: 10px 0;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  color: #140f40;\n  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06);\n  z-index: 50; /* Ensure footer stays above other content */\n}\nfooter span {\n  color: #3bc3f8; /* New blue color (Tailwind's blue-600) */\n  opacity: 1;\n  text-align: center;\n  font-weight: 500;\n}\nfooter li {\n  margin-left: 30px;\n}\n\n.light footer {  \n  color: #ffffff;\n  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.headingContainer {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n}\n\n/* Add body padding to prevent content from being hidden behind fixed footer */\nbody {\n  padding-bottom: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
